module.exports = __webpack_public_path__ + "img/dropdown-icon-down.64299853.svg";